// NodeLocationField.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { openGoogleMaps } from 'utilities/googleMapsNavigation';

// CSS
import './NodeLocationField.css';

// Icons
import Icon from 'svg/Icon';

// Components
import TextInput from 'components/textinput/TextInput';
import NodeLocationModal from 'node/form/fields/location/NodeLocationModal';

/**
 * NodeLocationField
 * 
 * Displays the location section for a node or a button to add location if none exist.
 * 
 * @param {object|null} value - Current location field value.
 * @param {Function} onLocationSaved - Callback when location is saved.
 *  
 *
 * @returns {ReactNode} - NodeLocation component.
 */
const NodeLocationField = ({ value, onLocationSaved, readOnly = false }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- STATE ----- //

    // State

    const [locationOpen, setLocationOpen] = useState(false);

    // ----- HANDLERS ----- //

    /**
 * Handles navigate.
 */

    const handleNavigate = () => {
        openGoogleMaps(value);
    };

    // ----- RENDER ----- //

    return (
        <>
            <div className="node-location-field-container">

                {/* ROW */}
                <div className="node-location-row">

                    <TextInput
                      style={{
                            cursor: readOnly ? 'default' : 'pointer',
                        }}
                      value={value?.titleFull || value?.title || ''}
                      placeholder={readOnly ? '' : 'Add a location...'}
                      readOnly
                      startIconKey="pin_drop"
                      startIconColor={theme.foregroundMuted}
                      iconSize={22}
                      expandable
                      multiline
                      hybrid
                      onClick={readOnly ? undefined : () => setLocationOpen(true)}
                    />

                    {/* BUTTON */}
                    {value ? (
                        <div
                          className="node-location-navigate"
                          title="Open in Google Maps"
                          onClick={handleNavigate}
                        >

                            <Icon
                              iconKey="open_in_new"
                              color={theme.foregroundMuted}
                              size={18}
                            />

                        </div>
                    ) : null}

                </div>

            </div>

            {!readOnly ? (
                <NodeLocationModal
                  value={value}
                  isOpen={locationOpen}
                  setOpen={setLocationOpen}
                  onLocationSaved={onLocationSaved}
                />
            ) : null}
        </>
    );
};

// Dev Tools
NodeLocationField.displayName = 'NodeLocationField';

export default NodeLocationField;
